import { MessageCircle } from "lucide-react";

import "./rodapeWhatsApp.css";

/**
 * Botão fixo no rodapé do acompanhamento que abre o WhatsApp da loja com a
 * mensagem do pedido pronta (dono, 24/10/2026: "sempre vai lembrar o cliente
 * de ir para o WhatsApp"). Entra subindo com um quique e, de tempos em tempos,
 * um brilho passa e o ícone balança.
 */
export default function RodapeWhatsApp({ link, emAndamento, escuro }) {
  if (!link) return null;
  return (
    <div className={`fixed inset-x-0 bottom-0 z-20 px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))] bg-gradient-to-t ${escuro ? "from-zinc-900 via-zinc-900/95" : "from-gray-50 via-gray-50/95"} to-transparent`}>
      <a href={link} target="_blank" rel="noopener noreferrer" data-e2e="rodape-whatsapp"
        className="rw-botao relative overflow-hidden max-w-xl mx-auto flex items-center gap-3 rounded-2xl bg-[#25D366] text-white px-4 py-3 shadow-lg shadow-emerald-500/30 active:scale-[0.98] transition-transform">
        <span className="rw-brilho" aria-hidden="true" />
        <span className="rw-icone w-10 h-10 rounded-full bg-white/20 grid place-items-center shrink-0"><MessageCircle className="w-5 h-5" /></span>
        <span className="min-w-0 flex-1 text-left">
          <span className="block text-base font-black leading-tight">{emAndamento ? "Acompanhar no WhatsApp" : "Falar com a loja no WhatsApp"}</span>
          <span className="block text-xs leading-tight mt-0.5 text-white/90">{emAndamento ? "A loja te avisa de cada etapa do pedido" : "Tire suas dúvidas sobre o pedido"}</span>
        </span>
      </a>
    </div>
  );
}
